import React from 'react';
import Form from '../../components/common/Form';

class DeleteTeamModal extends Form {
    constructor(props) {
        super(props);
        this.state = {
            done: false,
            data: {
                team_name: props.team_name || "",
                team_id: props.team_id || "",
                admin_id: props.admin_id || ""
            },
            errors: {}
        };
    }

    doSubmit = (e) => {
        const data = this.state.data;
        this.props.acceptModal(e, data);
    };


    render() {
        let {visible_modal, onClickAway, team_name} = this.props;

        return (

            <div id="teamModal" className="modal" style={visible_modal ? {display: "block"} : {display: "none"}}>
                <div className="modal-content">
                    <div className="onboarding-panel">

                        <h1 className="m-m-b onboarding-title">Delete Team Data</h1>
                        <div className="separator"></div>
                        <div className="form-group m-m-b">

                            <span
                                className="danger-text">Are you certain that you want to delete: <strong>{team_name}</strong> ?</span>
                        </div>
                        <div className="separator m-m-b"></div>
                        <div className="submit-buttons row">
                            <div className="col-md-6">
                                <button disabled={false}
                                        onClick={onClickAway}
                                        name="cancel_team"
                                        id="cancel_team"
                                        type="button"
                                        className='btn-grey btn-xs text-bold'>Cancel
                                </button>
                            </div>
                            <div className="col-md-6 text-right save-submit">
                                <button disabled={false}
                                        name="change_team"
                                        id="delete_team_btn"
                                        type="button"
                                        onClick={this.doSubmit}
                                        className='btn-action btn-danger btn-lg m-xl-b'
                                        style={{backgroundColor: "rgb(239, 72, 72)", color: "white"}}>Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default DeleteTeamModal;